// import spellCheck from 'src/utils/spell-check';


// const specialCharacterPattern = new RegExp(/[~`!#$%\^&*+=()@\[\]\\;,/{}|\":<>\?\']/);
const emailPattern = new RegExp(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
// const mobilePattern = new RegExp(/^\d+$/);
// const integerGreaterThan0 = new RegExp(/^[1-9]+[0-9]*$/);
// const invalidText = (invalidChars) => { return `The character${invalidChars.length > 1 ? 's' : ''} ${invalidChars.length > 1 ? 'are' : 'is'} not allowed.` };
// const fieldRequiredText = 'This field is required';
const fieldRequiredText = 'Không để trống trường này';
const fieldContainSpaceText = 'This field can not contain spaces';
const emailInvalidText = 'Email không hợp lệ';
const spellErrorText = 'Có lỗi chính tả!';

const validateCreatePostForm = (values, edited = false) => {
  let errors = {};
  if (!values.title) {
    errors.title = {
      required: fieldRequiredText
    };
  }
  if (!values.title_google) {
    errors.title_google = {
      required: fieldRequiredText
    };
  }
  if (!values.url) {
    errors.url = {
      required: fieldRequiredText
    };
  }

  if (!values.keyword) {
    errors.keyword = {
      required: fieldRequiredText
    };
  }

  if (values.keyword) {
    // check keyword in lowercase to avoid case-sensitive
    let keywordLowercase = values.keyword.toLowerCase();
    if (values.title && !values.title.toLowerCase().includes(keywordLowercase)) {
      errors.keyword = {
        ...errors.keyword,
        titleHasKeyword: `Tiêu đề chưa có keyword '${values.keyword}'`
      };
    }
    if (values.title_google && !values.title_google.toLowerCase().includes(keywordLowercase)) {
      errors.keyword = {
        ...errors.keyword,
        titleGoogleHasKeyword: `Tiêu đề Google chưa có keyword '${values.keyword}'`
      };
    }
    if (values.description && !values.description.toLowerCase().includes(keywordLowercase)) {
      errors.keyword = {
        ...errors.keyword,
        descriptionHasKeyword: `Tóm tắt nội dung chưa có keyword '${values.keyword}'`
      };
    }
    if (values.description_google && !values.description_google.toLowerCase().includes(keywordLowercase)) {
      errors.keyword = {
        ...errors.keyword,
        descriptionGoogleHasKeyword: `Tóm tắt nội dung Google chưa có keyword '${values.keyword}'`
      };
    }
  }

  if (!values.description) {
    errors.description = {
      required: fieldRequiredText
    };
  }
  if (!values.description_google) {
    errors.description_google = {
      required: fieldRequiredText
    };
  }

  if(values.sourcename && !isLink(values.sourcename)){
    errors.sourcename = `Invalid link nguồn`;
  }

  return errors;
}

const isLink = (value) => {
  console.log(value);
  return value && /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/ig.test(value) ? 
  true : false;
}

const validateCreateUserForm = (values, edited = false) => {
  let errors = {};
  if (!values.username) {
    errors.username = fieldRequiredText;
  }

  // if (!values.password) {
  //   errors.password = fieldRequiredText;
  // }
  if (!values.fullname) {
    errors.fullname = fieldRequiredText;
  }

  if (!values.email) {
    errors.email = fieldRequiredText;
  } else if (!emailPattern.test(values.email)) {
    errors.email = emailInvalidText;
  }

  return errors;
}

const validateUpdateUserForm = (values, edited = false) => {
  let errors = {};
  if (!values.username) {
    errors.username = fieldRequiredText;
  }

  if (!values.fullname) {
    errors.fullname = fieldRequiredText;
  }

  if (!values.email) {
    errors.email = fieldRequiredText;
  } else if (!emailPattern.test(values.email)) {
    errors.email = emailInvalidText;
  }

  return errors;
}

const composeAsyncValidators = (validatorFns) => {
  return async (values, dispatch, props, field) => {
    const validatorFn = validatorFns[field]
    await validatorFn(values, dispatch, props, field);
  };
}

const validatePrice = (value, allValues, props, name) => {
  if(!value || value == 0) return fieldRequiredText; 
  if(value < 0) return "Giá phải lớn hơn 0";
  return undefined
}

const validateDiscount = (value, allValues, props, name) => {
  if(value && (value < 0 || value > 100)) {
    console.log(value);
    return "Discount từ 0%-100%"
  }
  return undefined
}

// const spellCheckTitle = (values) => {
//   return spellCheck(values.title).then((data) => {
//     if (data) {
//       throw {
//         title: {
//           spell: data
//         }
//       };
//     }
//   })
// };

// const spellCheckTitleGoogle = (values) => {
  
//   return spellCheck(values.title_google).then((data) => {
//     if (data) {
//       throw {
//         title_google: {
//           spell: data
//         }
//       };
//     }
//   })
// };
// const spellCheckDescription = (values) => {
//   return spellCheck(values.description).then((data) => {
//     if (data) {
//       throw {
//         description: {
//           spell: data
//         }
//       };
//     }
//   })
// };

// const spellCheckDescriptionGoogle = (values) => {
  
//   return spellCheck(values.description_google).then((data) => {
//     if (data) {
//       throw {
//         description_google: {
//           spell: data
//         }
//       };
//     }
//   })
// };

// const asyncValidate = composeAsyncValidators({
//   title: spellCheckTitle,
//   title_google: spellCheckTitleGoogle,
//   description: spellCheckDescription,
//   description_google: spellCheckDescriptionGoogle
// });

export {
  validateCreatePostForm,
  validateCreateUserForm,
  validateUpdateUserForm,
  validatePrice,
  validateDiscount
  // asyncValidate
}
